export { ArrowUpNarrow as default } from './ArrowUpNarrow';
